(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const initReveal = () => {
    const items = qsa('.sareno-reveal, .sareno-reference-section, .spread, .atelier-section');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach((item) => observer.observe(item));
  };

  const initAtelierProgress = () => {
    const bar = qs('[data-sareno-reading-progress]');
    const railLinks = qsa('[data-sareno-rail-link]');
    const sections = railLinks
      .map((link) => {
        const id = link.getAttribute('href')?.replace('#', '');
        return id ? qs(`#${CSS.escape(id)}`) : null;
      })
      .filter(Boolean);

    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? window.scrollY / max : 0;
      if (bar) bar.style.transform = `scaleX(${Math.min(Math.max(ratio, 0), 1)})`;

      let activeId = sections[0]?.id;
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= window.innerHeight * 0.38) activeId = section.id;
      });
      railLinks.forEach((link) => {
        link.toggleAttribute('aria-current', link.getAttribute('href') === `#${activeId}`);
      });
    };

    if (bar || railLinks.length) {
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
  };

  const initLookbook = () => {
    const spreads = qsa('[data-sareno-lookbook-spread], .spread');
    const railItems = qsa('[data-sareno-lookbook-index]');
    if (!spreads.length) return;

    const setActive = () => {
      let active = 0;
      spreads.forEach((spread, index) => {
        const rect = spread.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.46) active = index;
      });
      railItems.forEach((item, index) => {
        item.toggleAttribute('aria-current', index === active);
      });
    };

    const go = (direction) => {
      let active = 0;
      spreads.forEach((spread, index) => {
        if (spread.getBoundingClientRect().top <= window.innerHeight * 0.46) active = index;
      });
      const next = Math.min(Math.max(active + direction, 0), spreads.length - 1);
      spreads[next]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    window.addEventListener('scroll', setActive, { passive: true });
    window.addEventListener('resize', setActive);
    document.addEventListener('keydown', (event) => {
      if (event.defaultPrevented) return;
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName)) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') go(1);
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') go(-1);
    });
    setActive();
  };

  const initGiftCardAmounts = () => {
    qsa('[data-sareno-gift-amount]').forEach((button) => {
      button.addEventListener('click', () => {
        const root = button.closest('[data-sareno-gift-card]');
        if (!root) return;
        qsa('[data-sareno-gift-amount]', root).forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        const output = qs('[data-sareno-gift-selected]', root);
        if (output) output.textContent = button.textContent.trim();
      });
    });
  };

  const init = () => {
    document.documentElement.classList.add('sareno-js');
    initReveal();
    initAtelierProgress();
    initLookbook();
    initGiftCardAmounts();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
